var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserTenantRep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.1118,
    cy: 22.8003,
    r: 22.3003,
    fill: "#2BA700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.93 16.9466C26.93 19.0291 25.2185 20.7212 23.112 20.7212C21.0055 20.7212 19.2939 19.0291 19.2939 16.9466C19.2939 14.864 21.0055 13.1719 23.112 13.1719C25.2185 13.1719 26.93 14.864 26.93 16.9466Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1121 22.9609C19.6627 22.9609 16.7399 25.0956 15.555 28.0893C15.0284 29.469 16.1343 30.9528 17.6352 30.9528H28.589C30.0898 30.9528 31.1957 29.469 30.6691 28.0893C29.5105 25.0956 26.5615 22.9609 23.1121 22.9609Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTenantRep);
export default __webpack_public_path__ + "static/media/User_Tenant_Rep.7bec1d86ab4d6c59068fa292dbc7424f.svg";
export { ForwardRef as ReactComponent };